module.exports = __webpack_public_path__ + "img/moonriver.d17d3a76.svg";